import { Button, Paper, TextField } from '@material-ui/core';
import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { changePassword, ILoginAction } from '../../store/actions/auth';

class Account extends React.Component<any, any> {
  public state = {
    oldPassword: '',
    newPassword: '',
  };

  public onChange(input: 'oldPassword' | 'newPassword') {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({
        [input]: event.target.value,
      });
    };
  }

  public onSubmit() {
    return (event: React.FormEvent<any>) => {
      this.props.changePassword(this.state.oldPassword, this.state.newPassword);
      event.preventDefault();
    };
  }

  public render() {
    return (
      <Paper>
        <form autoComplete="off" onSubmit={this.onSubmit()}>
          <TextField
            required={true}
            label="Old Password"
            type="password"
            margin="normal"
            onChange={this.onChange('oldPassword')}
          />
          <br />
          <TextField
            required={true}
            label="New Password"
            type="password"
            margin="normal"
            onChange={this.onChange('newPassword')}
          />
          <br />
          <Button variant="contained" type="submit">
            Save
          </Button>
        </form>
      </Paper>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<ILoginAction>) => {
  return {
    changePassword: (oldPassword: string, newPassword: string) =>
      dispatch(changePassword(oldPassword, newPassword)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(Account);



// WEBPACK FOOTER //
// ./src/screens/Account/Account.tsx